var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center h-16 pl-4 space-x-4 ledge"},[(!_vm.noLogo)?_c('StreamLogo'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }